module.exports = __webpack_public_path__ + "static/media/banner_alibaba@2x.4bedaaee.jpg";